const GetUsers = 'UserManagement/GetUsers'
const GetAllUsers = 'UserManagement/GetAllUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const CreateUser = 'User/CreateUser'
const UpdateUser = 'User/UpdateUser'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetCategories = "Common/GetCategories"
const GetCategorieTypesDescription = "Common/UpdateCategoriesAndTypes"
const GetAllKeys = 'Cache/GetAllKeys'
const GetKeyDetails = 'Cache/GetKeyDetails'
const GetKeyCategories = 'Cache/GetKeyCategories'
const DeleteKeys = 'Cache/DeleteKeys'
const GetFilteredEnvelopes = 'DocuSign/GetFilteredEnvelopes'
const GetEnvelopebyEnvelopeId = 'DocuSign/GetEnvelopebyEnvelopeId'
const GetCombinedDocuments = 'DocuSign/GetCombinedDocuments'
const GetCertificate = 'DocuSign/GetCertificate'
const GetEnvelopeCustomFields = 'DocuSign/GetEnvelopeCustomFields'
const GetEnvelopeRecipients = 'DocuSign/GetEnvelopeRecipients'
const GetEnvelopeDocuments = 'DocuSign/GetEnvelopeDocuments'
const GetNotification = 'DocuSign/GetNotification'
const ReSendDocument = 'DocuSign/ReSendDocument'
const VoidEnvelope = 'DocuSign/VoidEnvelope'
const DownloadDocument = 'DocuSign/DownloadDocument'
const GetServiceBusTopics = 'ServiceBus/GetTopics'
const GetServiceBusSubscriptions = 'ServiceBus/GetSubscriptions'
const GetServiceBusCounts = 'ServiceBus/GetCounts'
const GetDeadLetterMessages = 'ServiceBus/GetDeadLetterMessages'
const GetDeadLetterMessageById = 'ServiceBus/GetDeadLetterMessageById'
const GetDeadLetterMessageProperties = 'ServiceBus/GetDeadLetterMessageProperties'
const RetryDeadLetterMessage = 'ServiceBus/RetryDeadLetterMessage'


export const ApiUrls = {
  GetUsers,
  GetAllUsers,
  GetUserRoles,
  SaveUserRoles,
  CreateUser,
  UpdateUser,
  GetAllRoles,
  GetCategories,
  GetCategorieTypesDescription,
  GetAllKeys,
  GetKeyDetails,
  GetKeyCategories,
  DeleteKeys,
  GetFilteredEnvelopes,
  GetEnvelopebyEnvelopeId,
  GetCombinedDocuments,
  GetCertificate,
  GetEnvelopeCustomFields,
  GetEnvelopeRecipients,
  GetEnvelopeDocuments,
  GetNotification,
  ReSendDocument,
  VoidEnvelope,
  DownloadDocument,
  GetServiceBusTopics,
  GetServiceBusSubscriptions,
  GetServiceBusCounts,
  GetDeadLetterMessages,
  GetDeadLetterMessageById,
  GetDeadLetterMessageProperties,
  RetryDeadLetterMessage
}
